import * as React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import cx from 'classnames';

import { Route } from 'core';
import { Error401, Error404 } from '../errors';

import pageCss from './page.css';
import { ADMIN_PERMISSIONS, PermissionProvider } from 'contexts/permissions/permission-provider';

export interface IPageProps {
    className?: string;
    title?: React.ReactNode;
    children?: React.ReactNode;
}

export const Page = (props: IPageProps) => {
    return <div className={cx(pageCss.wrapper, props.className)}>{props.children}</div>;
};

export interface IPermissionPageProps extends IPageProps {
    routes: Route[];
    permissionCodes: string[];
}

export const PermissionPage = (props: IPermissionPageProps) => {
    const errorPage = getErrorPage(props);
    return errorPage != null ? (
        errorPage
    ) : (
        <div className={cx(pageCss.wrapper, props.className)}>
            {props.title ? <h1>{props.title}</h1> : null}
            {props.children}
        </div>
    );
};

function getErrorPage(props: IPermissionPageProps) {
    const path = useLocation().pathname;
    const matchedRoute = props.routes?.find((route) => matchPath(route, path));
    if (!matchedRoute) return <Error404 message='Page Not Found' />;
    if (!matchedRoute.hasPermission(props.permissionCodes))
        return <Error401 message='No permission to access' />;
    return null;
}

export const AdminPermissionWrappedProvider = (props: IPermissionPageProps & { requiredPermissionCodes?: ADMIN_PERMISSIONS[] }) => (
    <PermissionProvider requiredPermissions={props.requiredPermissionCodes ?? []} groups={['Admin']}>
        <PermissionPage {...props} />
    </PermissionProvider>
);
export const KeysPermissionWrappedProvider = (props: IPermissionPageProps & { requiredPermissionCodes?: string[] }) => (
    <PermissionProvider requiredPermissions={props.requiredPermissionCodes ?? []} groups={['Keys']}>
        <PermissionPage {...props} />
    </PermissionProvider>
);
export const DevicesPermissionWrappedProvider = (props: IPermissionPageProps & { requiredPermissionCodes?: string[] }) => (
    <PermissionProvider requiredPermissions={props.requiredPermissionCodes ?? []} groups={['Device Attributes', 'Device Actions', 'Devices']}>
        <PermissionPage {...props} />
    </PermissionProvider>
);
export const SoftwarePermissionWrappedProvider = (props: IPermissionPageProps & { requiredPermissionCodes?: string[] }) => (
    <PermissionProvider requiredPermissions={props.requiredPermissionCodes ?? []} groups={['Software']}>
        <PermissionPage {...props} />
    </PermissionProvider>
)